var _path, _path2, _rect, _rect2, _rect3, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCertificationPending(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 128,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "certification-pending_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 129,
    height: 128
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M.5 0h128v128H.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#certification-pending_svg__a)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M109.602 88.186c0 8.238-6.663 14.916-14.883 14.916H32.484c-8.22 0-14.882-6.678-14.882-14.916v-50.17c0-8.237 6.663-14.914 14.882-14.914h62.235c8.22 0 14.883 6.677 14.883 14.915v50.17z",
    fill: "#E7EBEF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 29.5,
    y: 36,
    width: 68,
    height: 6,
    rx: 3,
    fill: "#A0AFBE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 29.5,
    y: 48,
    width: 42,
    height: 6,
    rx: 3,
    fill: "#B8C3CE"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 29.5,
    y: 60,
    width: 25,
    height: 6,
    rx: 3,
    fill: "#B8C3CE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "certification-pending_svg__b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 58,
    width: 65,
    height: 64
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M55.5 58h64v64h-64z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#certification-pending_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.5 100.733c.489.489 1.089.733 1.8.733.71 0 1.333-.266 1.866-.8.49-.489.734-1.11.734-1.866s-.245-1.378-.734-1.867l-8-8v-9.667c0-.755-.255-1.377-.765-1.866-.512-.49-1.146-.734-1.901-.734-.756 0-1.389.255-1.899.766-.512.512-.768 1.145-.768 1.901v10.6c0 .356.067.7.2 1.032.133.334.333.635.6.901l8.867 8.867zm-7 15.933c-3.69 0-7.156-.7-10.4-2.101-3.245-1.399-6.067-3.299-8.467-5.699-2.4-2.4-4.3-5.222-5.699-8.466-1.4-3.245-2.101-6.711-2.101-10.4 0-3.69.7-7.156 2.101-10.4 1.4-3.245 3.299-6.067 5.699-8.467 2.4-2.4 5.222-4.3 8.467-5.701 3.244-1.4 6.71-2.099 10.4-2.099 3.689 0 7.155.7 10.4 2.099 3.244 1.4 6.066 3.301 8.466 5.701 2.4 2.4 4.3 5.222 5.699 8.467 1.401 3.244 2.101 6.71 2.101 10.4 0 3.689-.7 7.155-2.101 10.4-1.399 3.244-3.299 6.066-5.699 8.466-2.4 2.4-5.222 4.3-8.466 5.699-3.245 1.401-6.711 2.101-10.4 2.101z",
    fill: "#A0AFBE"
  })))));
}
export default SvgCertificationPending;